import antdFrFR from 'antd/es/locale/fr_FR';
import axios from "axios";
import { env } from 'configs/EnvironmentConfig';

const fetchMessages = async () => {
  const response = await axios.get(process.env.NODE_ENV === 'production' ? env.IMG_SRC + '/locales/fr_FR.json' : 'https://apitest.tunimobile.com/locales/fr_FR.json'); // Replace with your URL
  if (response.status !== 200) {
    throw new Error(`Failed to load translations: ${response.statusText}`);
  }
  return await response.data;
};

const FrLang = {
  antd: antdFrFR,
  locale: 'fr-FR',
  fetchMessages
};
export default FrLang;
